import { renderDayMonthYear } from '../../../../utils/formatter'

export const KUInfoConfig = (data: any) => [
    {
        name: 'Дата подачи',
        value: renderDayMonthYear(data.ts_created),
    },
]
